import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Col } from 'reactstrap';
import { Loader } from '../../../components/loader';
import { fetchImageSore } from '../actions/store';
import { fetchImages } from '../actions/images';
import { ImageCard } from './imageCard';
import { DestroyModalContainer } from './destroyModal';
import _ from 'underscore';

class Gallery extends Component {
    static initialState() {
        return {
            image_src: false,
            isLocalLoad: false,
            file: false,
        };
    }

    constructor(props) {
        super(props);
        this.state = Gallery.initialState();
        this.onChangeFile = this.onChangeFile.bind(this);
        this.refreshData = this.refreshData.bind(this);
    }

    componentWillMount() {
        const props = this.props;
        if (props.isNotReady) {
            this.refreshData();
        }
    }

    componentDidUpdate(nextProps, nextState, nextContext) {
        const props = this.props;
        if (
            props.storeData.isFetching &&
            !nextProps.storeData.isFetching &&
            !nextProps.storeData.didInvalidate
        ) {
            this.setState(Gallery.initialState());
        }
    }

    refreshData() {
        const props = this.props;
        if (!props.isFetching) {
            props.getImages();
        }
    }

    onChangeFile(e) {
        const file =
            e.target.files && e.target.files[0] ? e.target.files[0] : null;

        let reader = new FileReader();
        if (!file) {
            this.setState(Gallery.initialState());
            return;
        }
        reader.onloadstart = () => {
            this.setState({
                isLocalLoad: true,
            });
        };
        reader.onloadend = () => {
            this.setState({
                isLocalLoad: false,
                file: file,
                image_src: reader.result,
            });
        };
        reader.readAsDataURL(file);
    }

    render() {
        const props = this.props,
            state = this.state,
            response = props.response,
            images = response.images || [];
        // let isFetching = props.modal.isFetching;
        // let isInvalid = props.modal.didInvalidate;
        return (
            <div>
                <div className="modal-scroll">
                    {props.isFetching ? (
                        <Loader />
                    ) : props.didInvalidate ? (
                        <h2 className="mt-4 text-center">
                            <span>Ошибка при запросе, </span>
                            <span onClick={this.refreshData}>
                                попробовать еще
                            </span>
                        </h2>
                    ) : (
                        <div>
                            <Col
                                md={3}
                                className="d-inline-block align-top p-1"
                            >
                                <div className="img-loader">
                                    {!state.isLocalLoad &&
                                    !props.storeData.isFetching ? null : (
                                        <Loader />
                                    )}
                                    <img
                                        alt={'+'}
                                        className="img-loader-img"
                                        src={
                                            state.image_src ||
                                            '/img/add-photo.png'
                                        }
                                    />
                                    <input
                                        className="img-loader-input"
                                        accept="image/jpeg,image/png,image/gif,image/bmp,image/ico,image/x-icon"
                                        type="file"
                                        onChange={this.onChangeFile}
                                    />
                                </div>
                                {!state.file ||
                                state.isLocalLoad ||
                                props.storeData.isFetching ? null : (
                                    <Button
                                        color="success"
                                        onClick={() =>
                                            props.imageStore(state.file)
                                        }
                                    >
                                        Загрузить
                                    </Button>
                                )}
                            </Col>
                            {_.map(images, (image) => {
                                return (
                                    <Col
                                        md={3}
                                        key={image.uuid}
                                        className="d-inline-block p-1 align-top"
                                    >
                                        <ImageCard
                                            image={image}
                                            onDestroy={props.openModalDestroy}
                                            route={props.route}
                                        />
                                    </Col>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const MapStateToProps = function mapStateToProps(state) {
    return {
        route: state.appState.route,
        isFetching: state.imagesState.isFetching,
        isNotReady: state.imagesState.isNotReady,
        didInvalidate: state.imagesState.didInvalidate,
        storeData: state.imagesState.storeData,
        response: state.imagesState.response,
    };
};

const mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        getImages: () => {
            dispatch(fetchImages());
        },
        imageStore: (file) => {
            if (!file) return;
            dispatch(
                fetchImageSore({
                    image_file: file,
                })
            );
        },
        openModalDestroy: (image) => {
            dispatch({
                type: 'openMiniModal',
                header: 'Удаление изображения',
                children: <DestroyModalContainer image={image} />,
                onClose: () => {
                    dispatch({ type: 'closeMiniModal' });
                },
            });
        },
        dispatch,
    };
};

export const GalleryContainer = connect(
    MapStateToProps,
    mapDispatchToProps
)(Gallery);
